module.exports = __webpack_public_path__ + "img/share-content_zh-CN.8269ed7e.png";